namespace pageTopInfoConfig {
    export const customerProject = "審査通過おめでとうございます！🎉　面談のご協力ありがとうございました。案件稼働までの流れについて、サービスご利用開始前にご一読お願いします。"
    export const customerMessage = "企業様とメッセージのやり取りを行う際のポイントと注意点です。メッセージのやり取りを開始する前に、確認しましょう。"
    export const customerMypage = "企業様からたくさんスカウトを受け取る為に、マイページを充実させましょう！マイページ作成はこちらをご参照ください。※職歴情報を頂ける場合OR事前に頂いている場合、弊社での代理作成が可能です。チャットボットより、お気軽にお申し付けください。"
    export const customerClientBlock = "事前に特定企業をブロックすることで、特定企業から自分のプロフィール情報の閲覧を防ぐことが可能です。企業ブロックの方法はこちらをご参照ください。"
    export const customerContract = "複数の契約情報、取引情報、請求書情報を一元管理する事ができます。"
    export const customerActivity = "契約情報に紐づけて、稼働時のメモや稼働報告書に必要な内容を書き留めておくことができます。"
    export const customerInvoice = "契約情報を登録して頂く事で、その契約に基づいた請求書を簡単に作成する事が出来ます。"
    export const clientScout = "貴社の求める優秀な登録エキスパートをスカウトすることが可能です。スカウトする方法～面談設定までの流れと注意点について、ご利用前にご一読お願いします。"
    export const clientMessage = "スカウトしたORエントリーを受けたエキスパートにメッセージを送付することができます。メッセージ開始～稼働までの流れについてご一読の上、積極的にメッセージを送付してみましょう！"
    export const clientProject = "エキスパートへのスカウト及びエントリーを受けるには、案件の登録が必要です。案件登録方法やその他案件登録にまつわるQ&Aについては、こちらをご参照ください。"
    export const clientMember = "社内メンバーへの個別アカウントの付与が可能です。メンバーアカウントの作成方法、およびメンバーアカウントの権限変更方法やその他アカウント周りのQ&Aは、こちらをご参照ください。"
}

export {
    pageTopInfoConfig
}


// WEBPACK FOOTER //
// ./src/config/language/ja-JP/presentation/page_top_info_text.ts